import parsePhoneNumber from 'libphonenumber-js';

export function removeUnnecessaryCharsFromNumber(number: string) {
  if (number == null) {
    return '';
  }

  if (number.startsWith('sip:')) {
    return number;
  } else {
    return number.replaceAll(/\(\s*0\s*\)|[^+*0-9]/g, ''); // Remove all (0) and every character except +, * and digits.
  }
}

export function normalizeNumber(number?: string | null): string | null {
  try {
    if (!number) return null;
    return parsePhoneNumber(number, 'DE')!.format('E.164');
  } catch (_: any) {
    return null;
  }
}

export function isPhoneNumberValid(number: string): boolean {
  try {
    const phoneNumber = parsePhoneNumber(number);
    return !!phoneNumber && phoneNumber.isValid();
  } catch {
    return false;
  }
}

const PHONE_WILDCARD_PATTERN = /^\+?\d[\d ]*\*$/;

const isGlobalWildcard = (v: string) => v === '*';
const isPhoneWildcard = (v: string) => PHONE_WILDCARD_PATTERN.test(v);

export function isBlacklistPatternValid(value: string): boolean {
  const trimmed = value?.trim();
  return !!trimmed && (isGlobalWildcard(trimmed) || isPhoneWildcard(trimmed) || isPhoneNumberValid(trimmed));
}

export function categorizePhoneNumber(number: string): 'mobile' | 'work' {
  const cleanNumber = removeUnnecessaryCharsFromNumber(number);

  const parsed = parsePhoneNumber(cleanNumber, 'DE');
  if (parsed?.getType() === 'MOBILE') {
    return 'mobile';
  }

  return 'work';
}
